import { render } from "./LinkCateg.vue?vue&type=template&id=26fd63e8&scoped=true"
import script from "./LinkCateg.vue?vue&type=script&lang=js"
export * from "./LinkCateg.vue?vue&type=script&lang=js"

import "./LinkCateg.vue?vue&type=style&index=0&id=26fd63e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26fd63e8"]])

export default __exports__